import { EFinancingCompany, EFinancingProgram } from '@if/core/types'

interface FinancingCompany {
  Id: EFinancingCompany
  FinancingPrograms: EFinancingProgram[]
}

const companies: FinancingCompany[] = [
  {
    Id: EFinancingCompany.IFinance,

    FinancingPrograms: [EFinancingProgram.Personal, EFinancingProgram.B2c],
  },
  {
    Id: EFinancingCompany.Iceberg,
    FinancingPrograms: [
      EFinancingProgram.Auto,
      EFinancingProgram.IfXpress,
      EFinancingProgram.Products,
      EFinancingProgram.AutoRsla,
      EFinancingProgram.CreditRsla,
      EFinancingProgram.MechanicalWarranty,
    ],
  },
]

export const getProgramsByCompanyId = (companyIds: EFinancingCompany[]): EFinancingProgram[] => {
  const programs: EFinancingProgram[] = []
  companyIds.forEach((companyId) => {
    const company = companies.find((x) => x.Id === companyId)
    if (company) {
      programs.push(...company.FinancingPrograms)
    }
  })
  return programs
}

export const getCompanyIdByProgram = (program: EFinancingProgram): EFinancingCompany => {
  const company = companies.find((company) => company.FinancingPrograms.includes(program))
  if (!company) {
    throw new Error(`No company found for financing program: ${program}`)
  }
  return company.Id
}

export default companies
